export const spacing = {
  none: 0,
  xxxsmall: '2px',
  xxsmall: '4px',
  xsmall: '8px',
  small: '12px',
  medium: '16px',
  large: '20px',
  xlarge: '32px',
};

export const fontSizes = {
  xsmall: '0.79rem',
  small: '0.889rem',
  medium: '1.2rem',
  xmedium: '1.4rem',
  large: '1.125rem',
  xlarge: '1.266rem',
};
